import { omitScoringFields } from 'shared/utilities/format';

export function findMembership(company, userId) {
  if (!company?.memberships || userId == null) {
    return null;
  }
  return company.memberships.find((entry) => Number(entry.user_id) === Number(userId)) || null;
}

export function aggregateEntitlementCredits(items = []) {
  return items.reduce((totals, entitlement) => ({
    total_credits: totals.total_credits + Number(entitlement.total_credits || 0),
    available_credits: totals.available_credits + Number(entitlement.available_credits || 0),
    reserved_credits: totals.reserved_credits + Number(entitlement.reserved_credits || 0),
    consumed_credits: totals.consumed_credits + Number(entitlement.consumed_credits || 0),
  }), {
    total_credits: 0,
    available_credits: 0,
    reserved_credits: 0,
    consumed_credits: 0,
  });
}

export function buildDashboard({ entitlements = {}, participants = {}, codes = {} } = {}) {
  const entitlementItems = entitlements.items || [];
  const participantItems = participants.items || [];
  const codeItems = codes.items || [];
  const credits = aggregateEntitlementCredits(entitlementItems);
  const activeEntitlements = entitlementItems.filter((item) => item.status === 'active').length;

  return {
    credits,
    stats: {
      active_plans: activeEntitlements,
      active_codes: codes.meta?.total ?? codeItems.filter((item) => item.status === 'active').length,
      claimed_codes: codeItems.filter((item) => ['claimed', 'completed'].includes(item.status)).length,
      completed_assessments: participantItems.filter((item) => item.status === 'completed').length,
    },
    recent_participants: participantItems.slice(0, 5).map(mapParticipant),
  };
}

export function mapParticipant(participant) {
  if (!participant || typeof participant !== 'object') {
    return participant;
  }
  return {
    ...participant,
    full_name: participant.participant?.name || participant.full_name,
    attempt_status: participant.status,
    attempt_status_label: participant.status_label,
    profile_code: participant.result?.profile_code,
    code_masked: participant.code_masked,
    batch_label: participant.batch?.label,
  };
}

export function mapPurchase(purchase, payment = null) {
  if (!purchase || typeof purchase !== 'object') {
    return purchase;
  }
  const mergedPayment = payment || {
    mode: purchase.payment_mode,
    provider: purchase.payment_provider,
    reference: purchase.payment_reference,
    checkout_url: purchase.checkout_url,
  };
  return {
    ...purchase,
    payment: mergedPayment,
  };
}

export function mapSponsoredResult(payload) {
  if (!payload || typeof payload !== 'object') {
    return payload;
  }
  const result = payload.result || payload;
  return omitScoringFields(result);
}

export function mapAccessCode(code) {
  if (!code || typeof code !== 'object') {
    return code;
  }
  return {
    ...code,
    can_revoke: code.status === 'active',
    participant_name: code.claimed_by?.name,
    batch_label: code.batch?.label,
  };
}
